export default {
    _prefix: "qualityFormEditor.automatedScoring",
    labels: {
        title: "Automated Scoring",
        options: {
            noAutomation: "No Automation",
            aiScoring: "AI Scoring",
            evaluationAssistance: "Evaluation Assistance",
        },
        warningForSwitching: "Switch to a different option",
        tooltip: {
            aiScoringMaxQuestionsTooltip: (maxAIScoringQuestions: {
                maxAIScoringQuestions: number;
            }) =>
                "An evaluation form can have a maximum of {{maxAIScoringQuestions}} questions configured with AI Scoring.",
            aiScoringAnswerLimitReached: (maxAIScoringAnswerOptionCount: {
                maxAIScoringAnswerOptionCount: number;
            }) =>
                "Multiple choice questions with AI Scoring enabled may not have more than {{maxAIScoringAnswerOptionCount}} answer options.",
            noAiScoringEditPermission:
                "You do not have the necessary permissions to configure AI Scoring for this form.",
            noEvaluationAssistancePermission:
                "You do not have the necessary permissions to configure Evaluation Assistance for this form.",
            noAutomatedScoringPermission:
                "You do not have the necessary permissions to edit the Automated Scoring status of this question.",
            noPermissionAndAiScoringLimitReached:
                "You do not have the necessary permissions to configure Evaluation Assistance for this form. AI Scoring configuration limits for this form have been reached.",
            noAutomatedScoringOptionSelected:
                "Automated scoring must be selected for auto-submission forms",
            evaluationAssistanceConditionRequired:
                "Evaluation assistance condition must be added to one answer",
        },
        modalTitle: {
            noAutomation: "Remove Automated Scoring?",
            aiScoring: "Switch to AI Scoring?",
            evaluationAssistance: "Switch to Evaluation Assistance?",
        },
        modalContent: {
            noAutomation:
                "Any Evaluation Assistance conditions or AI scoring configured for this question will be lost.",
            aiScoring:
                "Any Evaluation Assistance conditions configured for this question will be lost.",
            evaluationAssistance:
                "Any AI scoring configured for this question will be lost.",
        },
        modalFooter: {
            confirm: "Confirm",
            cancel: "Cancel",
        },
        aiScoringInfoMessage:
            "AI Scoring uses information from the Question Group, Question, Help Text, and Answers fields to score questions. If the contents of these fields change, the AI prompt will update automatically.",
    },
};
